<template>
  <v-container fluid class="pa-0">
    <template v-if="driverDetails">
      <component :is="componentConfig.type" v-bind="componentConfig.propsData" />
    </template>
  </v-container>
</template>

<style scoped>
.section-header {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #767676;
  }
</style>

<script>
import apiService from '@/services/shared/agentPortalApiService.js';
import { mapState, mapActions } from 'vuex';

import AutoDetail from '@/components/Client/LineOfBusiness/Drivers/Driver/AutoDetail.vue';
import OperatorDetail from '@/components/Client/LineOfBusiness/Drivers/Driver/OperatorDetail.vue';

export default {
  name: 'DriverDetail',
  components: {
    AutoDetail,
    OperatorDetail
  },
  data: function () {
    return {
      loading: true,
      driverDetails: null,
      viewingMore: false
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    driverId: function () {
      return this.$route.params.driverId;
    },
    componentConfig: function () {
      var type = 'AutoDetail';
      if ((this.driverDetails || null) !== null && this.driverDetails.type === 1) {
        type = 'OperatorDetail';
      }

      return {
        type: type,
        propsData: {
          loading: this.loading,
          driverDetails: this.driverDetails
        }
      };
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getLineOfBusinessDriverDetail(this.clientId, this.policyOrderNumber, this.lobCode, this.driverId);
    if (rs.code === 0) {
      if ((rs.data || null) !== null && rs.data.length > 0) {
        this.driverDetails = rs.data[0];
      } else {
        this.driverDetails = null;
      }
    } else {
      this.setError(rs.message || 'An error occurred.');
    }
    this.loading = false;
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
